import { Outlet, Link } from '@tanstack/react-router';
import { Container } from '@/components/ui/container';
import { Button } from '@/components/ui/button';
import { ThemeToggle } from '@/components/ui/theme-toggle';
import { MadeBy } from '@/components/ui/made-by';
import { useScrolled } from '@/lib/use-scrolled';
import { cn } from '@/lib/cn';
import { useSession } from '@/lib/session';

/** Chrome for the marketing site + legal pages. */
export function PublicLayout() {
  const scrolled = useScrolled();
  const { isAuthed } = useSession();

  return (
    <div className="relative flex min-h-dvh flex-col overflow-x-clip">
      <header
        className={cn(
          'sticky top-0 z-40 transition-[background-color,border-color,backdrop-filter] duration-300 ease-soft',
          scrolled
            ? 'border-b-2 border-ink bg-canvas/80 backdrop-blur-xl'
            : 'border-b-2 border-transparent',
        )}
      >
        <Container className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-display text-lg font-semibold">
            <span
              className="rounded-blob inline-block size-4 bg-accent ring-2 ring-inset ring-ink/15"
              aria-hidden
            />
            Nearmirer
          </Link>
          <div className="flex items-center gap-2">
            <ThemeToggle />
            {!isAuthed && (
              <Button asChild variant="outline" size="sm">
                <Link to="/login">Log in</Link>
              </Button>
            )}
            <Button asChild variant="candy" size="sm">
              <Link to={isAuthed ? '/app' : '/signup'}>{isAuthed ? 'Open app' : 'Sign up'}</Link>
            </Button>
          </div>
        </Container>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="relative border-t-2 border-ink bg-flavor-grape-soft pt-12">
        <Container className="flex flex-col gap-6 pb-12">
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold text-ink-soft">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/community-guidelines">Community Guidelines</Link>
            <Link to="/safety">Safety Center</Link>
          </div>
          <p className="text-xs text-ink-faint">
            Nearmirer is 18+. Be kind, stay safe, meet in public. © {new Date().getFullYear()}{' '}
            Nearmirer, Inc. · <MadeBy />
          </p>
        </Container>
      </footer>
    </div>
  );
}
